import LoadingIcon from '@/assets/images/common/svg/loading.svg?react';
import classes from './index.module.scss';

export const Loading = ({
  bold,
  className,
}: {
  bold?: boolean;
  className?: ClassNames;
}) => {
  return (
    <div className={cls(classes.loading, className)}>
      <div className={cls(classes.content, bold && classes.bold)}>
        <LoadingIcon className={classes.icon} />
        <div className={classes.text}>loading...</div>
      </div>
    </div>
  );
};
